<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M16.666 3.33301H3.33268C2.41352 3.33301 1.66602 4.08051 1.66602 4.99967V14.9997C1.66602 15.9188 2.41352 16.6663 3.33268 16.6663H16.666C17.5852 16.6663 18.3327 15.9188 18.3327 14.9997V4.99967C18.3327 4.08051 17.5852 3.33301 16.666 3.33301ZM5.41602 5.83301C5.74754 5.83301 6.06548 5.9647 6.2999 6.19912C6.53432 6.43354 6.66602 6.75149 6.66602 7.08301C6.66602 7.41453 6.53432 7.73247 6.2999 7.96689C6.06548 8.20131 5.74754 8.33301 5.41602 8.33301C5.08449 8.33301 4.76655 8.20131 4.53213 7.96689C4.29771 7.73247 4.16602 7.41453 4.16602 7.08301C4.16602 6.75149 4.29771 6.43354 4.53213 6.19912C4.76655 5.9647 5.08449 5.83301 5.41602 5.83301ZM9.99935 14.1663H4.16602L7.49935 9.99967L8.74935 11.6663L11.2493 8.33301L15.8327 14.1663H9.99935Z"
            fill="currentColor"
        />
    </svg>
</template>
